/**
 * Enum of tab names used in Settings.
 */
export enum FitTestTab {
  Details = 'details',
  Protocols = 'protocols',
  Respirator = 'resprator',
  Results = 'results'
}
